export default __webpack_public_path__ + "static/media/18.cf008fc7.jpg";